import { listOfStringsTypeFiltersCombiner } from "./listOfStringsTypeFiltersCombiner";
import { RootState } from "../../../../store";
import { resourceExplorerAppliedFiltersSelector } from "../resourceExplorerAppliedFiltersSelector";

export const appliedInstanceTypesSelector = (state: RootState) => {
  const filters = resourceExplorerAppliedFiltersSelector(state);

  return listOfStringsTypeFiltersCombiner("instance_type", filters);
};
